import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'startFrom', standalone: true })
@Injectable({providedIn: 'root'})
export class StartFromPipe implements PipeTransform {
	
	transform(input, start) {
		if (input) {
			start = parseInt(start);
			return input.slice(start);
		}
		return [];
	}
	
}